module.exports = __webpack_public_path__ + "img/海桐皮.3e084de4.jpg";